import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAttachment = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m21 12.396-6.309 6.308a6.85 6.85 0 0 1-9.685-9.686l4.393-4.392a4.549 4.549 0 1 1 6.433 6.433l-4.285 4.286A2.296 2.296 0 1 1 8.3 12.097l4.043-4.044"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAttachment);
export default ForwardRef;
